import { useId, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import dynamic from "next/dynamic";

import IconArrow from "assets/svg/chevron_right_black.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import { listItems } from "./list-items";

import { handleReportModalOpened } from "@/src/store/listingDetail";

import ModalTextContent from "components/modal-text-content";
import SecuritySuggestions from "modal-contents/security-suggestions";

import styles from "./styles.module.css";

const Modal = dynamic(() => import("components/common/modal"), { ssr: false });

const SidebarList = () => {
  const keyId = useId();
  const dispatch = useDispatch();
  const [isModalOpened, setIsModalOpened] = useState(false);

  const handleClick = (id, eventLabel) => {
    Ga4WithEventParameters({
      eventName: "form",
      eventParameters: { label: `view||${eventLabel}` },
    });
    switch (id) {
      case 1:
        setIsModalOpened(true);
        break;
      case 2:
        dispatch(handleReportModalOpened());
        break;
      default:
        break;
    }
  };
  return (
    <>
      <ul className={styles.wrapper}>
        {listItems.map((item, index) => (
          <li key={`${keyId}-${index}`} onClick={() => handleClick(item.id, item.ga4EventLabel)}>
            <div className={styles.titleWrap}>
              <span className={styles.iconWrap}>{item.icon}</span>
              <h4 className={styles.title}>{item.title}</h4>
            </div>
            <p className={styles.info}>{item.content}</p>
            <span className={styles.redirectWrap}>
              <IconArrow />
            </span>
          </li>
        ))}
      </ul>
      <Modal isOpen={isModalOpened} handleClose={() => setIsModalOpened(false)}>
        <ModalTextContent style={{ maxWidth: 450 }}>
          <SecuritySuggestions />
        </ModalTextContent>
      </Modal>
    </>
  );
};

SidebarList.propTypes = {
  children: PropTypes.node,
};

export default SidebarList;
